import React from 'react';

const MeasureIconActive = ({ ...props }) => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4724_21984)">
      <path
        d="M8.61719 32.8062V28.0812M14.5403 32.8062V27.0312M20.4633 32.8062V28.0812M26.9249 32.8062V27.0312M32.848 32.8062V28.0812"
        stroke="#003E7D"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M3.23438 24.9375V31.7625C3.23438 32.1125 3.44976 32.8125 4.3113 32.8125C5.17284 32.8125 26.9267 32.8125 37.6959 32.8125C38.0549 32.8125 38.7728 32.6025 38.7728 31.7625C38.7728 30.9225 38.7728 26.8625 38.7728 24.9375"
        stroke="#003E7D"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M31.7656 15.4922H39.3041"
        stroke="#003E7D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.5312 11.8125L39.3005 15.4875L35.5312 19.1625"
        stroke="#003E7D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.226 15.4922H2.6875"
        stroke="#003E7D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.45673 19.1625L2.6875 15.4875L6.45673 11.8125"
        stroke="#003E7D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4724_21984">
        <rect width="42" height="42" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MeasureIconActive;
